import { Card, CardContent } from './card'
import { Skeleton } from './skeleton'
import { LucideIcon } from 'lucide-react'

interface MetricCardProps {
  label: string
  value: string | number
  icon?: LucideIcon
  loading?: boolean
  className?: string
}

export function MetricCard({ label, value, icon: Icon, loading = false, className = '' }: MetricCardProps) {
  if (loading) {
    return (
      <Card className={`border ${className}`}>
        <CardContent className="p-4 md:p-6">
          <div className="flex items-center justify-between">
            <div className="space-y-2 flex-1">
              <Skeleton className="h-3 w-20 rounded-full" />
              <Skeleton className="h-8 w-16 rounded-full" />
            </div>
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card className={`border ${className}`}>
      <CardContent className="p-4 md:p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-xs font-medium text-muted-foreground">{label}</p>
            <p className="text-2xl md:text-3xl font-bold">{value}</p>
          </div>
          {Icon && <Icon className="h-8 w-8 text-muted-foreground dark:text-white" />}
        </div>
      </CardContent>
    </Card>
  )
}
